jQuery(document).ready(function ($) {

    $('.js-collapsible--expanded .js-collapsible__content').show();

    $(document).on('click', '.js-collapsible__trigger', function () {
        if ($(this).parents('.js-collapsible').eq(0).hasClass('js-collapsible--expanded')) {
            $(this).parents('.js-collapsible').eq(0).removeClass('js-collapsible--expanded').find('.js-collapsible__content').eq(0).stop().slideUp(250);
        } else {
            $(this).parents('.js-collapsible').siblings('.js-collapsible').removeClass('js-collapsible--expanded').find('.js-collapsible__content').stop().slideUp(250);
            $(this).parents('.js-collapsible').eq(0).addClass('js-collapsible--expanded').find('.js-collapsible__content').eq(0).stop().slideDown(250);
        }
    });
});
